import moment from 'moment';

import type { User } from '../types/User';

export const MINIMUM_START_DATE = moment.utc('2025-07-13');

// Stamped into `onboardingTips` when an account is created through the live
// webinar signup path (WebinarSignupModal for email/password, the WebinarLive
// onboarding effect for OAuth). Onboarding tours/tips were globally paused for
// the 2026-08-12 webinar so they wouldn't fire mid-presentation; they are now
// re-enabled for everyone EXCEPT users who came in through that path, who are
// walked through the product live and shouldn't get the popup chain afterward.
export const WEBINAR_SIGNUP_ORIGIN_KEY = 'webinar-signup-origin';

// True when the user's account originated from the webinar signup path. Used to
// keep onboarding tours suppressed for those users while everyone else sees
// them. Reads the durable `onboardingTips` flag so it survives reloads and is
// available wherever the profile is loaded.
export const didSignUpViaWebinar = (user: User | null | undefined): boolean =>
  user?.onboardingTips?.[WEBINAR_SIGNUP_ORIGIN_KEY] === true;
